<template lang="pug">
el-collapse(v-model='collapse')
    el-collapse-item(name='informacoes_gerais')
        h3.font_weight_bold(
            slot='title',
            style='color: var(--primary-font-color)'
        ) {{ $t('mensagens.diagnosticoSocioambiental.informacoesGerais') }}
        .d-flex.flex-column
            div.d-flex.flex-row
                .d-flex.flex-column.informacoes-gerais-dado
                    h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.municipioUf') }}
                    span.font_weight_bold {{ informacoes_gerais.localidade ? informacoes_gerais.localidade : '--' }}
                .d-flex.flex-column.informacoes-gerais-dado
                    h4.informacoes-gerais {{ areaLabel }}
                    span.font_weight_bold {{ areaValorFormatado }}
                .d-flex.flex-row.informacoes-gerais-dado
                    .d-flex.flex-column(v-if="exibirAreaAgricultavel")
                        h4.informacoes-gerais(style='text-wrap: nowrap') {{ $t('mensagens.diagnosticoSocioambiental.areaAgricultavel') }}
                        span.font_weight_bold {{ informacoes_gerais.areaAgricultavelHaFormatada || '--' }}

                    //-  Botão desabilitado enquanto não utiliza a base correta para exibir o visual correto
                    //- .d-flex.flex-column.area-agricultavel-button(
                    //-     v-if='informacoes_gerais.areaAgricultavelHaFormatada && informacoes_gerais.areaAgricultavelHaTotal !== 0'
                    //- )
                    //-     el-button(
                    //-         size='mini',
                    //-         icon='mdi mdi-crosshairs-gps',
                    //-         @click='aplicarZoomAreaAgricultavel()'
                    //-     )
            div.d-flex.flex-row
                div.d-flex.flex-column.informacoes-gerais-dado
                    h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.bioma') }}
                    span.font_weight_bold {{ informacoes_gerais.bioma ? informacoes_gerais.bioma : '--' }}
                div(v-if="tipoPesquisa === 'CODIGOCAR' || tipoPesquisa === 'CAR_OPERACAO'").d-flex.flex-column.informacoes-gerais-dado
                    h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.moduloFiscal') }}
                    span.font_weight_bold {{ informacoes_gerais.moduloFiscalFormatado || informacoes_gerais.moduloFiscal || '--' }}
                div(v-if="tipoPesquisa === 'CODIGOCAR' || tipoPesquisa === 'CAR_OPERACAO'").d-flex.flex-column.informacoes-gerais-dado
                    h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.situacao') }}
                    span.font_weight_bold {{ informacoes_gerais.situacao ? validaSituacao(informacoes_gerais.situacao) : '--' }}

            div.d-flex.flex-row
                div(v-if="tipoPesquisa === 'CODIGOCAR'").d-flex.flex-column.informacoes-gerais-dado
                        h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.aderiu') }} PRA
                        span.font_weight_bold {{ informacoes_gerais.aderiuPra !== null ? (informacoes_gerais.aderiuPra ? $t('mensagens.comuns.sim') : $t('mensagens.comuns.nao')) : '--' }}
                div(v-if="tipoPesquisa === 'CODIGOCAR'").d-flex.flex-column.informacoes-gerais-dado
                        h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.situacaoReservaLegal') }}
                        span.font_weight_bold {{ informacoes_gerais.situacaoReservaLegal ? informacoes_gerais.situacaoReservaLegal : '--' }}
                div(v-if="tipoPesquisa === 'CODIGOCAR'").d-flex.flex-column.informacoes-gerais-dado
                        h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.dataAtualizacaoDados') }}
                        span.font_weight_bold {{ informacoes_gerais.camadaCar.dataAtualizacaoDados ? informacoes_gerais.camadaCar.dataAtualizacaoDados : '--' }}

            div.d-flex.flex-row
                div(v-if="tipoPesquisa === 'CODIGOCAR' || tipoPesquisa === 'CAR_OPERACAO'").d-flex.flex-column.informacoes-gerais-dado.col3
                    h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.condicao') }}
                    span.font_weight_bold {{ informacoes_gerais.condicao ? informacoes_gerais.condicao : '--' }}

            //- Campos específicos do CAR Estadual MT
            div.d-flex.flex-row(v-if="informacoes_gerais.base")
                div.d-flex.flex-column.informacoes-gerais-dado
                    h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.nomePropriedade') }}
                    span.font_weight_bold {{ informacoes_gerais.nomePropriedade || '--' }}
                div.d-flex.flex-column.informacoes-gerais-dado
                    h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.situacaoCarEstadual') }}
                    span.font_weight_bold {{ formatarSituacaoCarEstadual(informacoes_gerais.situacaoCar || informacoes_gerais.situacao) }}
                div.d-flex.flex-column.informacoes-gerais-dado
                    h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.baseOrigem') }}
                    span.font_weight_bold {{ formatarBase(informacoes_gerais.base) }}

            div.d-flex.flex-row(v-if="informacoes_gerais.carFederal")
                div.d-flex.flex-column.informacoes-gerais-dado.col3
                    h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.carFederalVinculado') }}
                    span.font_weight_bold {{ informacoes_gerais.carFederal }}

        p.text-right.text-info(
            style='padding-top: 10px',
            @click='openSiCARNewTab',
            v-if='tipoPesquisa == "CODIGOCAR"'
        )
            span.link-button(style='cursor: pointer') {{ $t('mensagens.diagnosticoSocioambiental.verDemonstrativoSicar') }}
                i.lyra-seguir-link.ml-3
</template>

<script>
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
import EventBus from '@/utils/eventBus';
import { mapState } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'card-informacoes-gerais-car',

    data() {
        return {
            collapse: ['informacoes_gerais']
        };
    },

    components: {
        Criticidade
    },

    props: {
        informacoes_gerais: {
            type: Object,
            required: true
        },
        refMapa: {
            required: true
        },
        tipoPesquisa: {
            type: String
        },
        pesquisado: {
            required: false,
            type: String
        }
    },

    computed: {
      ...mapState(['usuarioLogado']),

      isNorthAmerica() {
        return (
          this.usuarioLogado &&
          this.usuarioLogado.paisGrupo === AmbientesEmpresas.NORTE_AMERICA
        );
      },

      areaLabel() {
        if (this.isNorthAmerica) {
          if (this.$te('mensagens.diagnosticoSocioambiental.areaAcre')) {
            return this.$t('mensagens.diagnosticoSocioambiental.areaAcre');
          }
          return (this.$t('mensagens.diagnosticoSocioambiental.area') || 'Área') + ' (acres)';
        }
        return this.$t('mensagens.diagnosticoSocioambiental.areaHa');
      },

      areaValorFormatado() {
        if (this.informacoes_gerais && this.isNorthAmerica && this.informacoes_gerais.area_ac) {
          return this.informacoes_gerais.area_ac;
        }

        if (this.informacoes_gerais && this.informacoes_gerais.areaHaFormatada) {
          return this.informacoes_gerais.areaHaFormatada;
        }

        if (this.informacoes_gerais && this.informacoes_gerais.areaHa) {
          return this.informacoes_gerais.areaHa;
        }

        if (this.informacoes_gerais && this.informacoes_gerais.area_ha) {
          return this.informacoes_gerais.area_ha;
        }

        return '--';
      },

      exibirAreaAgricultavel() {
        return !this.isNorthAmerica;
      }
    },

    methods: {
        formatNumber(value, maxFractionDigits) {
			try {
				var locale = (this.$i18n && this.$i18n.locale) || undefined;
				return Number(value).toLocaleString(locale, {
					minimumFractionDigits: 0,
					maximumFractionDigits: typeof maxFractionDigits === 'number' ? maxFractionDigits : 2
				});
			} catch (e) {
				return (Math.round(value * 100) / 100) + '';
			}
		},
        validaSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.ativo'
                    );
                case 'PE':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.pendente'
                    );
                case 'SU':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.suspenso'
                    );
                case 'CA':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.cancelado'
                    );
            }
        },
        async aplicarZoomAreaAgricultavel() {
            await EventBus.$emit('fecharCollapses');
            await this.refMapa.aplicarZoomGeoAreaAgricultavel(
                this.informacoes_gerais.areaAgricultavel
            );
        },
        openSiCARNewTab() {
            navigator.clipboard.writeText(this.pesquisado);
            this.$notify.success({
                message:
                    'O número do CAR foi copiado para sua área de transferência, você está sendo direcionado para o site do SICAR'
            });

            setTimeout(() => {
                window.open('https://www.car.gov.br/#/consultar', '_blank');
            }, 3000);
        },
        formatarSituacaoCarEstadual(situacao) {
            if (!situacao) return '--';
            // Remove colchetes se existirem
            const situacaoLimpa = situacao.replace(/[[\]]/g, '');

            // Mapeamento das situações do CAR Estadual MT
            const mapeamento = {
                'AGUARDANDO_ANALISE': 'Aguardando Análise',
                'AGUARDANDO_ANALISE_PRA': 'Aguardando Análise PRA',
                'AGUARDANDO_COMPLEMENTACAO': 'Aguardando Complementação',
                'AGUARDANDO_ENVIO_PRA': 'Aguardando Envio PRA',
                'CANCELADO': 'Cancelado',
                'CAR_VALIDADO': 'CAR Validado',
                'CAR_VALIDADO_EM_REGULARIZACAO': 'CAR Validado em Regularização',
                'EM_ANALISE': 'Em Análise',
                'INDEFERIDO': 'Indeferido'
            };

            return mapeamento[situacaoLimpa] || situacaoLimpa.replace(/_/g, ' ');
        },
        formatarBase(base) {
            if (!base) return '--';
            // Formata o nome da base para exibição mais amigável
            const mapeamento = {
                'CAR_MT_VALIDADO': 'CAR MT - Validado',
                'CAR_MT_ANALISE': 'CAR MT - Em Análise',
                'CAR_MT_PENDENTE': 'CAR MT - Pendente'
            };
            return mapeamento[base] || base.replace(/_/g, ' ');
        }
    }
};
</script>

<style lang="scss" scoped>
.informacoes-gerais-dado {
    height: fit-content;
    width: 33%;
    padding: 8px 8px 8px 0px;
}

.font_weight_bold {
    font-weight: 500 !important;
}

.informacoes-gerais {
    font-size: 13px !important;
    height: 16px !important;
    font-weight: 400 !important;
    margin-bottom: 4px;
}

.caso-especial {
    height: 72px !important;
}

.area-agricultavel-button {
    width: 32px;
    padding-left: 5%;
    justify-content: center;

    .el-button {
        width: 31px !important;
        display: flex;
        justify-content: center;
    }
}

.col2 {
    width: 66%;
}

.col3 {
    width: 100%;
}

.link-button {
    color: var(--link);
    display: flex;
    justify-content: right;
    align-items: center;
    cursor: pointer;
    font-size: 14px !important;
}

.link-button:hover {
    text-decoration: underline;
}

.lyra-seguir-link {
    cursor: pointer;
    content: '';
    width: 14px;
    height: 14px;
    display: inline-block;
    -webkit-mask: url(../../assets/lyra-icons/svg/flecha-seguir.svg) no-repeat 50% 50%;
    mask: url(../../assets/lyra-icons/svg/flecha-seguir.svg) no-repeat 50% 50%;
    mask-size: cover;
    -webkit-mask-size: cover;
    background-color: var(--link);
    color: var(--link);
}

@media (max-width: 1430px) {
    .informacoes-gerais-dado {
        height: fit-content;
        width: 31%;
        padding: 8px 5px 8px 0px;
    }

    .caso-especial {
        height: 100px !important;
    }

    .area-agricultavel-button {
        width: 32px;
        padding-left: 10%;
        justify-content: center;
    }

    .col3 {
        width: 100%;
    }
}
</style>
